<template>
  <div class="flex">
    <label class="mx-2 mt-2">Reads For</label>
    <datepicker @selected="setDate" :value="earliest_reading" wrapper-class="" input-class="border-gray-300 placeholder-gray-500 appearance-none rounded-none relative block w-full px-3 py-2 border text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5 rounded-br-none rounded-tr-none" placeholder="Date" :disabled-dates="disabledDates"></datepicker>
    <a v-show="!enable_button"  ref="exportButton" href="" class="whitespace-no-wrap inline-flex items-center justify-center px-4 py-1 border border-transparent text-base leading-6 font-medium rounded-md rounded-bl-none rounded-tl-none text-white bg-gray-600 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition ease-in-out duration-150">
      Export Data
    </a>
    <a v-show="enable_button"  ref="exportButton" href="" class="whitespace-no-wrap inline-flex items-center justify-center px-4 py-1 border border-transparent text-base leading-6 font-medium rounded-md rounded-bl-none rounded-tl-none text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
      Export Data
    </a>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
export default {
  name: "DateExportButton",
  components: {
    Datepicker
  },
  data(){
    return {
      to_date: moment(this.newest_possible),
      enable_button: false,
      oldest_possible: moment(this.earliest_reading),
      newest_possible: moment(this.latest_reading),
      disabledDates: {
        customPredictor: this.isDisabled
      }
    };
  },
  props: {
    earliest_reading: {
      type: String,
    },
    latest_reading: {
      type: String,
    },
    community_id: {
      type: String,
    }
  },
  methods: {
    setDate(date) {
      if (date !== null) {
        this.to_date = moment(date).endOf("day");
        this.enable_button = true;
        this.$refs.exportButton.href = this.community_id + "/reads/for/" + this.to_date.unix() + "/export";
      }
    },
    isDisabled(date){
      return date.getTime() < this.oldest_possible.valueOf() ||  date.getTime() > this.newest_possible.valueOf();
    },
    mounted() {
      this.oldest_possible = moment(this.earliest_reading);
      this.newest_possible = moment(this.latest_reading);
      this.to_date = Date.parse(this.latest_reading);
    },
  }
}
</script>

<style scoped>

</style>
